/**
 * Serialize the focused Site Backup row for "download this" / "delete this".
 * @param {object} context mounted page context
 * @return {object} public site backup context
 */
export function serializeSiteBackupContext(context) {
	const route = String(context.route || '').toLowerCase();
	const onMaintenance = route === '/maintenance';
	const backupId = context.backup_id ?? context.backupId;
	const backupName = context.backup_name ?? context.backupName;
	const hasBackup = onMaintenance &&
		typeof backupId === 'string' &&
		Boolean(backupId);
	return {
		backup_id: hasBackup ? backupId : null,
		backup_name: hasBackup && typeof backupName === 'string' && backupName
			? backupName
			: null,
	};
}
